import { useQuery, useQueryClient } from "@tanstack/react-query";
import api from "../api/client";
import { qk, queryClient } from "../lib/queryClient";

// One request per admin page load for layout-level data (plan, subscription,
// microsites, notifications, sidebar badges). Every consumer below is a `select`
// view over the same cached query, so N hooks == 1 network call.
const fetchShell = () => api.get("/api/tenant/admin-shell").then((r) => r.data);

export function useAdminShell(select, options = {}) {
  return useQuery({
    queryKey: qk.adminShell,
    queryFn: fetchShell,
    select,
    ...options,
  });
}

export const usePlanUsage = (options) => useAdminShell((d) => d?.plan_usage ?? null, options);
export const useSubscriptionStatus = (options) => useAdminShell((d) => d?.subscription_status ?? null, options);
export const useMicrosites = (options) => useAdminShell((d) => d?.microsites ?? [], options);
export const useNotificationsData = (options) =>
  useAdminShell((d) => d?.notifications ?? { notifications: [], unread_count: 0 }, options);
export const useSidebarBadges = (options) => useAdminShell((d) => d?.badges ?? {}, options);

export function invalidateAdminShell() {
  return queryClient.invalidateQueries({ queryKey: qk.adminShell });
}

// Optimistic patch for mutations that already know the outcome (e.g. mark-all-read).
export function patchAdminShell(updater) {
  queryClient.setQueryData(qk.adminShell, (old) => (old ? updater(old) : old));
}

export function useInvalidateAdminShell() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: qk.adminShell });
}
